/**
 * Form selection gallery directive
 *
 * Usage:
 *
 *   controller.js:
 *     vm.handleSelection = function(selectedForm) { ... }
 *
 *   view.html:
 *     <button cm-form-gallery on-select="vm.handleSelection">Select form</button>
 */
angular.module('clientDashboardApp.reviewBuilder').directive('cmFormGallery', function($uibModal) {
  let openModal = function(parentScope) {
    let modalInstance = $uibModal.open({
      controller: modalGalleryCtrl,
      controllerAs: 'vm',
      template: require("./formSelector.html"),
      windowClass: 'gallery-modal',
      scope: parentScope,
      size: 'lg'
    });

    modalInstance.result.then(parentScope.onSelect);
  };

  return {
    restrict: 'A',
    scope: {
      onSelect: '=',
      selectedForm: '='
    },
    link: function(scope, element) {
      element.on('click', () => openModal(scope));
    }
  }

});

modalGalleryCtrl.$inject = ['$scope', 'reviewGenService', '$uibModal', '$stateParams', 'confirmService', 'userService'];
function modalGalleryCtrl($galleryScope, reviewGenService, $uibModal, $stateParams, confirmService, userService) {
  this.sampleForms = require('./defaultReviewForms');
  this.query = '';

  let vm = this;

  vm.numberOfFormsToPage = 5

  vm.reviewFormsPaged = {
    pageNumber:1,
    count: 0
  }

  userService.currentUser().then(user => this.user = user);

  this.isLoading = true;

  vm.loadMoreResults = function() {
    if ($galleryScope.selectedForm) {
      //if a form has been selected, remove that form from the larger array, and page fewer results
      this.items = this.items.filter(item => item._id != $galleryScope.selectedForm._id)
      vm.numberOfFormsToPage = 5
    }
    else {
      vm.numberOfFormsToPage = 6
    }
    var begin = (vm.reviewFormsPaged.pageNumber-1)*vm.numberOfFormsToPage
    var end = ((vm.reviewFormsPaged.pageNumber-1)*vm.numberOfFormsToPage)+vm.numberOfFormsToPage
    this.filteredItems = this.items.slice(begin, end);
    if ($galleryScope.selectedForm) {
      this.filteredItems.unshift($galleryScope.selectedForm); // And push the selected form to the top
    }
    vm.isLoading = false
  };

  reviewGenService.searchReviewForms({"limitOpt":10000}).then(response => {
    vm.reviewFormsPaged.count = response.data.count
    this.items = response.data.forms;
    this.originalItems = this.items
    vm.loadMoreResults()
  }).finally(() => this.isLoading = false);

  this.select = form => $galleryScope.$close(form);

  this.filterItems = () => {
    vm.isLoading = true
    if (this.query.length > 0) {
      this.items = this.originalItems.filter(item => item.name.toLowerCase().includes(this.query))
    }
    else {
      this.items = this.originalItems
    }
    vm.reviewFormsPaged.count = this.items.length
    vm.loadMoreResults()
  };

  this.canModifyForm = function(form) {
    return this.user && (_.includes(this.user.permissions, "UserManagement") || form.creatorId == this.user.userId)
  }

  this.editForm = editForm;
  this.deleteForm = deleteForm;

  function editForm(selectedTemplate, mode, shouldCopy) {
    $stateParams.reviewForm = selectedTemplate;
    if (shouldCopy) {
      $stateParams.copy = 'copy';
    }
    let creatorModal = $uibModal.open({
      template: `
        <div class="modal-body" style="min-height: 300px;">
          <button type="button" style="margin: 10px 10px 0 0;" class="close" ng-click="$dismiss()" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <div ng-include="'angularModules/reviewBuilder/templates/reviewForms/edit/reviewFormEditor.html'"></div>
        </div>
      `,
      size: 'xl',
      controller: 'ReviewFormEditorCtrl as vm',
      resolve: {
        pageInfo: function (adminPageInfo) {
          return adminPageInfo.setIfFirstTimeAppLoad({type: 'reviewForm', mode: mode})
        },
        onComplete: function($q, $state) {
          let deferred = $q.defer();
          deferred.promise.then(form => {
            creatorModal.close();
            $galleryScope.$close(form);
          });
          return deferred;
        },
        isSharedDefault: function(RGSenderConfigService) {
          return RGSenderConfigService.getConfig().then(config => {
            return config.securityDefaults.areFormsShared;
          })
        },
        user: () => userService.currentUser()
      },
      windowClass: 'mega-modal gutterless'
    })
  }


  function deleteForm(form) {
    confirmService.confirm('Confirm Deletion', `Are you sure you want to delete the form, "${form.name}"?`, confirmService.DELETE)
      .then(agreed => {
        if (agreed) {
          reviewGenService.deleteReviewForm(form)
          vm.originalItems = vm.originalItems.filter(item => item._id != form._id)
          vm.filterItems()
        }
      })
  }
}
